<textarea [formControl]="formControl"
          [cols]="props.cols"
          [rows]="props.rows"
          class="form-control form-control-sm"
          [class.is-invalid]="showError"
          [formlyAttributes]="field"
          [style.resize]="props.allowResize ? 'vertical' : 'none'">
</textarea>